/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UserAddDTO.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import User from "../../User";
import {SelectField} from "../../../tools/model/form/SelectField";
import {Selectable} from "../../../tools/model/form/Selectable";
import {UserRoleDTO} from "../../dto/user/UserRoleDTO";
import {Role} from "../../../tools/model/enumerations/Role";

export default class UserRoleForm extends AbstractForm<UserRoleDTO> {
    constructor(user: User) {
        super();

        let selectableValues: Array<Selectable<Role>> = Object.values(Role).map(role => {
            return {value: role, name: role, disabled: false};
        })

        this.fields.set(UserRoleDTO.ROLES, new SelectField(
            selectableValues,
            UserRoleDTO.ROLES,
            (t: Translation) => t.roles,
            () => true,
            Type.SELECT,
            true,
            true,
            [],
            []
        ));

        this.load(UserRoleDTO.fromUser(user));
    }
}
